import { events } from '../../../util/Events';
import $ from 'jquery';

const SCHOOL_SERVICE = 'School';

export const CART_EVENT_UPDATED = 'schoolCartUpdated';
export const CART_TOGGLED = 'schoolCartToggled';

/**
 * This class handles getting and storing the carts content
 * This is the only central location where there calls are allowed
 * This is also the only locations where the cart events are emitted
 * Changing the DOM should be handled in the react components
 */
export class InSchoolCartService {

  /**
     * Set the initial cart equal to the array of training_ids stored
     * in the session, cartInschool is set by twig in base.twig
     *
     * note: this is the only location cartInschool is allowed;
     */
  constructor() {
    let sessionCart = cartInschool;
    if (sessionCart !== null && typeof sessionCart === 'object') {
      sessionCart = Object.values(sessionCart);
    }
    this._cart = (sessionCart && sessionCart !== null) ? sessionCart : [];
  }

  /**
     * Gets the carts content
     * @returns {string[]}
     */
  get() {
    return this._cart;
  }

  /**
     * Adds examentraining to the shopping cart
     * @returns {*|jQuery|boolean|*|*|*}
     * @param trainingId
     */
  addTraining(trainingId) {
    return $.ajax({
      url: ajax_link,
      method: 'POST',
      data: {
        action: 'lyceo',
        controller: SCHOOL_SERVICE,
        method: 'saveToSession',
        AddProduct: trainingId,
        nonce: ajax_nonce,
      },
      dataType: 'json',
      success: () => {
        this._addTrainingToLocalStore(trainingId);
      },
      error: (e) => {
        if (e.responseJSON.message) {
          $('#overlay')
            .fadeIn(300)
            .html('<div class="overlay-container" style="background-color: #74A0A3"><br><p>' + e.responseJSON.message + '</p><br></div>');
        }
      },

    });
  }

  /**
     * Removes training from the shopping cart
     * @param trainingId
     * @returns {*|jQuery|boolean|*|*|*}
     */
  removeTraining(trainingId){
    return $.ajax({
      url: ajax_link,
      method: 'POST',
      data: {
        action: 'lyceo',
        controller: SCHOOL_SERVICE,
        method: 'removeFromSession',
        RemoveProduct: trainingId,
        nonce: ajax_nonce,
      },
      dataType: 'json',
      success: () => {
        this._removeTrainingFromStore(trainingId);
      },
      error: () => {
        events.emit(CART_EVENT_UPDATED);
      },
    });
  }

  /**
     * Adds the training to the cart array
     *
     * @param trainingId
     */
  _addTrainingToLocalStore(trainingId) {
    this._cart.push(trainingId);
    events.emit(CART_EVENT_UPDATED);
  }

  /**
     * Searches the cart content and removes the training with the matching id
     * @param trainingId
     * @returns {boolean}
     */
  _removeTrainingFromStore(trainingId) {
    const cart = this.get();
    this._cart = cart.filter(item => parseInt(item) !== parseInt(trainingId));
    events.emit(CART_EVENT_UPDATED);
  }

  toggleCart() {
    events.emit(CART_TOGGLED);
  }

}

export let inSchoolCartService = new InSchoolCartService();
